import React from "react";
import FbxLoader from "../loaders/FbxLoader";

export default function Naushad(props) {
  return <FbxLoader {...props} />;
}
